import React from 'react'
import {useHistory} from "react-router"
import {useTranslation} from "react-i18next";

import {IonButton, IonButtons, IonIcon, IonItem, IonLabel, useIonAlert} from "@ionic/react"
import {
    checkmarkCircleOutline, checkmarkCircleSharp, keyOutline, keySharp,
    manOutline, manSharp, shieldCheckmarkOutline, shieldCheckmarkSharp
} from "ionicons/icons"

import {PersonGroup as ItemType} from "../../types/PersonGroup"
import IconPersonGroup from "../common/Icons/PersonGroup"

interface itemProps {
    item: ItemType
}

const ListItem: React.FC<itemProps> = ({ item }) => {

    const history = useHistory()
        , peopleCount: number = item.counts?.people || 0
        , lockingSystemPermissionsCount: number = item.counts?.lockingSystemPermissions || 0
        , [presentAlert] = useIonAlert()
        , {t} = useTranslation()

    const alertEnabled = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t('person-groups.alerts.enabled.header'),
            message: t('person-groups.alerts.enabled.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    const alertDefaultNewPersonAddKey = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        return presentAlert({
            header:  t('person-groups.alerts.default_new_person_add_key.header'),
            message: t('person-groups.alerts.default_new_person_add_key.message'),
            buttons: [{
                text: t('common.cancel'),
                role: 'cancel'
            }]
        })
    }

    const goToPersonGroupLockingSystemPermissions = (ev: any, personGroupId: number) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/person-groups/' + personGroupId + '/locking-system-permissions')
    }

    const goToPersonGroupPeople = (ev: any, personGroupId: number) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/person-groups/' + personGroupId + '/people')
    }

    return (
        <>
            <IonItem button detail routerLink={"/person-groups/" + item.id + '/view'} slot="start">
                <IconPersonGroup slot="start" />
                <IonLabel>
                    {item.name}
                    <p>
                        <span style={{ 'fontWeight': 300 }}>{item.description}</span>
                    </p>
                </IonLabel>
                <IonButtons slot="end">
                    <IonButton color="medium" fill="clear" size="large" style={{ 'fontSize': '1rem' }}
                               onClick={(e) => alertEnabled(e)}
                               title={t('person-groups.alerts.enabled.header').toString()}
                        >
                        <IonIcon slot="icon-only" color={item.isEnabled == true ? 'success' : 'light'}
                                 ios={checkmarkCircleOutline} md={checkmarkCircleSharp} />
                    </IonButton>

                    <div className="ion-hide-sm-down">
                        <IonButton color="medium" fill="clear" size="large" style={{ 'fontSize': '1rem' }}
                                   onClick={(e) => alertDefaultNewPersonAddKey(e)}
                                   title={t('person-groups.alerts.default_new_person_add_key.header').toString()}
                        >
                            <IonIcon slot="icon-only" color={item.defaultNewPersonAddKey == true ? 'success' : 'light'}
                                     ios={keyOutline} md={keySharp} />
                        </IonButton>

                        <span style={{ 'display': 'inline-block', 'minWidth': '75px' }}>
                            <IonButton
                                color={peopleCount ? 'medium' : 'light'}
                                fill="clear"
                                onClick={ (ev) => goToPersonGroupPeople(ev, item.id) }
                                size="large"
                                style={{ 'fontSize': '1rem' }}
                            >
                                <IonIcon slot="start" ios={manOutline} md={manSharp} />
                                {peopleCount ? peopleCount : '-'}
                            </IonButton>
                        </span>
                        <span style={{ 'minWidth': '80px' }}>
                            <IonButton
                                color={lockingSystemPermissionsCount ? 'medium' : 'light'}
                                fill="clear"
                                onClick={ (ev) => goToPersonGroupLockingSystemPermissions(ev, item.id) }
                                size="large"
                                style={{ 'fontSize': '1rem' }}
                            >
                                <IonIcon slot="start" ios={shieldCheckmarkOutline} md={shieldCheckmarkSharp} />
                                {lockingSystemPermissionsCount ? lockingSystemPermissionsCount : '-'}
                            </IonButton>
                        </span>
                    </div>

                </IonButtons>
            </IonItem>
        </>
    )
}

export default ListItem